  <template>
  <div class="col-12">
    <a
      class="btn btn-secondary btn-md btn-block"
      data-target="#modalAddProductoPrecio"
      data-toggle="modal"
      href="#"
      v-if="current.estado_str != 'Dado de baja'"
    >
      <i class="fas fa-plus"></i>
      &nbsp;
      <span>{{ titleButton }}</span>
    </a>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalAddProductoPrecio"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h5 class="onboarding-title text-center">Agregar tarima</h5>
              </div>
              <form @submit="aggTarimaContenedor">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="input-group">
                      <input
                        v-model="current.tarima_barra"
                        class="form-control"
                        placeholder="barra #"
                        type="text"
                        ref="barrax"
                      />
                      <small
                        v-if="current.errors && current.errors.tarima_barra"
                        class="form-text text-danger"
                        >{{ current.errors.tarima_barra[0] }}</small
                      >
                    </div>
                  </div>
                </div>
                <br />
                <button class="btn btn-primary btn-block" type="submit">
                  <i class="fas fa-plus"></i> Agregar
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modificarInformacionContenedor"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modificarInformacionContenedor"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Modificar Información del contenedor
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label>Tienda origen</label>
                  <div class="input-group">
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      required
                      v-model="current.tienda_origen"
                    >
                      <option value="">Seleccione una tienda</option>
                      <option
                        v-for="(tienda, key) in tiendas"
                        :value="tienda.codigo"
                        :key="key"
                      >
                        {{ tienda.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label>Tienda destino</label>
                  <div class="input-group">
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      required
                      v-model="current.tienda_destino"
                    >
                      <option value="">Seleccione una tienda</option>
                      <option
                        v-for="(tienda, key) in tiendas"
                        :value="tienda.codigo"
                        :key="key"
                      >
                        {{ tienda.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        current.errors.activo_fijo &&
                        current.errors.activo_fijo.length > 0,
                    }"
                    >Vehiculo</label
                  >
                  <div class="input-group">
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="current.activo_fijo"
                      @input="$emit('input', $event.target.value)"
                    >
                      <option
                        v-for="(af, key) in activos_fijos"
                        :value="af.id"
                        :key="key"
                      >
                        {{ af.placa }} {{ af.nombre }} ({{ af.identificador }})
                      </option>
                    </select>
                    <small
                      v-if="current.errors && current.errors.activo_fijo"
                      class="form-text text-danger"
                      >{{ current.errors.activo_fijo[0] }}</small
                    >
                  </div>
                </div>
              </div>
              <div v-if="current.usuario" class="col-sm-12">
                <UsuariosSelectComponent
                  :disabled="current.estado != 'A'"
                  titulo="Encargado"
                  :current="current"
                />
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label for>Nombre de Piloto</label>
                  <div class="input-group">
                    <input
                      v-model="current.piloto"
                      class="form-control"
                      placeholder="Nombre"
                      type="text"
                    />
                  </div>
                  <small
                    v-if="current.errors && current.errors.piloto"
                    class="form-text text-danger"
                    >{{ current.errors.piloto }}</small
                  >
                </div>
              </div>
              <div class="col-sm-12" v-if="current.activo_fijo == null">
                <div class="form-group">
                  <label for>Matricula</label>
                  <div class="input-group">
                    <input
                      v-model="current.matricula"
                      class="form-control"
                      placeholder="#"
                      type="text"
                    />
                  </div>
                  <small
                    v-if="current.errors && current.errors.matricula"
                    class="form-text text-danger"
                    >{{ current.errors.matricula }}</small
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              @click="guardarCambios()"
              type="button"
              class="btn btn-primary"
            >
              Guardar Cambios
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import ContenedorService from "@/services/wms/ContenedorService";
import DynamicService from "@/services/commons/DynamicService";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";

export default {
  props: {
    activos_fijos: [],
    current: {
      type: Object,
      required: true,
    },
    titleButton: {
      type: String,
      required: false,
      default: "Agregar Tarima",
    },
  },
  components: { UsuariosSelectComponent },
  data() {
    return {
      tiendas: [],
      cajas: [],
      cliente: {
        nit: null,
        email: "",
      },
      encargado: [],
    };
  },
  watch: {},
  computed: {},
  mounted() {
    let self = this;
    self.refreshTienda();
    $(".modal").on("shown.bs.modal", function () {
      self.$refs.barrax.focus();
    });
  },
  methods: {
    guardarCambios() {
      let self = this;
      var current = Object.assign({}, self.current);
      if (current.id == null) {
        delete current.id;
      }
      if (self.current.usuario) {
        current.encargado = self.current.usuario.id;
      }
      ContenedorService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.errors = {};

          Notifications.alert.success(
            "Contenedor",
            "Se ha Modificado la Información."
          );
          $("#modificarInformacionContenedor").modal("hide");
          self.$emit("refresh", {});
        })
        .catch((error) => {
          if (error.response) {
            self.current.errors = error.response.data;
          }
        });
    },
    refreshActivosFijos() {
      let self = this;
      DynamicService.fetch("af", "activo", {
        quitar_paginacion: true,
      }).then((res) => {
        self.activos_fijos = res.data;
      });
    },
    refreshTienda() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: true,
      }).then((response) => {
        self.tiendas = response.data;
      });
    },
    cerrandoModal() {
      $("#modalAddProductoPrecio").modal("hide");
    },
    aggTarimaContenedor(e) {
      let self = this;
      e.preventDefault();
      var det = Object.assign({}, this.current);
      let params = {
        tarima_barra:det.tarima_barra,
      }
      ContenedorService.asignar_tarima_a_contenedor(self.current.id, params)
        .then((res) => {  
          self.current.errors = {};
          Notifications.toast.success(
            "Tarima",
            "Se ha agregado una nueva tarima"
          );
          self.$emit("refresh", {});
          self.cerrandoModal();
        })
        .catch((error) => {
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
            
            // Handle different error response formats
            if ("detail" in error.response.data) {
              // Standard detail error message
              Notifications.alert.error("Error", error.response.data.detail);
            } else if (Array.isArray(error.response.data)) {
              // ValidationError returns an array of error messages
              const errorMessage = error.response.data.join(", ");
              Notifications.alert.error("Error", errorMessage);
            } else if (typeof error.response.data === 'string') {
              // String error message
              Notifications.alert.error("Error", error.response.data);
            }
          });
        });
    },
  },
};
</script>
